import {
    communityUpdateModel,
    communityUpdateImage
} from "../../../actions/community-actions"

import buildItemConnector from "../../common/build-item-connector"

export default buildItemConnector(
    "communities",
    false,
    communityUpdateModel,
    communityUpdateImage,
    {},
    ({ selectedParticipantType, activeId, isAddingMembers }) => ({
        participantType: selectedParticipantType,
        communityId: activeId,
        isAdding: isAddingMembers
    })
)
